<ng-container *ngIf="mergedCase">
  <div>
    <div class="aps">
      <div class="ambs">
        <span>{{ mergedCase.id }}</span>
        -
        <ng-container *ngIf="mergedCase.EntryCardId || mergedCase.fromProjectMom; else normalTitle">
          <T
            *ngIf="mergedCase.EntryCardId"
            str="Entry card request"></T>
          <T
            *ngIf="mergedCase.fromProjectMom"
            str="MOM for {fieldName}"
            [vars]="{ fieldName: mergedCase.Field?.name ?? '' }"></T>
        </ng-container>
        <ng-template #normalTitle>{{ mergedCase.name }}</ng-template>
      </div>

      <div
        class="amb"
        *ngIf="mergedCase.description && !mergedCase.fromProjectMom">
        <apex-title-item>
          <T
            title
            str="Description"></T>

          <apex-translator>
            <p class="rm">{{ mergedCase.description }}</p>
          </apex-translator>
        </apex-title-item>
      </div>

      <div class="display-grid">
        <ng-container *ngIf="mergedCase?.fromRequest">
          <apex-title-item>
            <T
              title
              str="Request created"></T>

            {{ mergedCase.fromRequestTime | dater | date: 'short' }}
          </apex-title-item>
        </ng-container>

        <ng-container *ngIf="mergedCase?.CaseCategory?.name">
          <apex-title-item>
            <T
              title
              str="Category"></T>

            {{ mergedCase.CaseCategory.name | translate }}
          </apex-title-item>
        </ng-container>

        <ng-container *ngIf="mergedCase.Project?.name">
          <apex-title-item>
            <T
              title
              str="Project"></T>

            {{ mergedCase.Project.name }}
          </apex-title-item>
        </ng-container>
        <ng-container *ngIf="mergedCase.Apartment?.name">
          <apex-title-item>
            <T
              title
              str="Unit"></T>

            {{ mergedCase.Apartment.name }}
          </apex-title-item>
        </ng-container>

        <ng-container *ngIf="mergedCase.Object?.name">
          <apex-title-item>
            <T
              title
              str="Object"></T>

            {{ mergedCase.Object.name }}
          </apex-title-item>
        </ng-container>

        <apex-title-item *ngIf="mergedCase.Field || mergedCase.ObjectField">
          <T
            title
            str="Discipline"></T>

          <div class="df ac">
            <div class="amr">
              <ng-container *ngIf="mergedCase.Field"> {{ mergedCase.Field.name }} </ng-container>
              <ng-container *ngIf="mergedCase.ObjectField"> {{ mergedCase.ObjectField.name }} </ng-container>
            </div>
            <apex-color-picker
              class="amrxs"
              disabled
              [(ngModel)]="(mergedCase.Field || mergedCase.ObjectField).color">
            </apex-color-picker>
          </div>
        </apex-title-item>
      </div>
    </div>
  </div>
</ng-container>
